import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/global/authSlice';
import alertReducer from './slices/global/alertSlice';
import searchReducer from './slices/global/searchSlice';
import conveyorFilterReducer from './slices/global/conveyorFilterSlice';
import themeReducer from './slices/global/themeSlice';
import channelsReducer from './slices/orders/channelsSlice';
import periodReducer from './slices/orders/periodSlice';
import utilsReducer from './slices/utils/utilsSlice';
import contextOptionsReducer from './slices/options/serviceOptionsSlice';
import serviceCategoriesReducer from './slices/options/serviceCategoriesSlice';
import serviceMonitorReducer from './slices/options/serviceMonitorSlice';
import fileContentsReducer from './slices/options/fileContentsSlice';
import handleErrorReducer from './slices/options/handleErrorSlice';
import packagesSlice from './slices/packages/packagesSlice';

const store = configureStore({
  reducer: {
    auth: authReducer,
    alert: alertReducer,
    search: searchReducer,
    conveyorFilter: conveyorFilterReducer,
    theme: themeReducer,
    channels: channelsReducer,
    period: periodReducer,
    utils: utilsReducer,
    serviceOptions: contextOptionsReducer,
    serviceCategories: serviceCategoriesReducer,
    serviceMonitor: serviceMonitorReducer,
    fileContents: fileContentsReducer,
    handleError: handleErrorReducer,
    packages: packagesSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;
// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
